import { NeutralColor } from "node-library/dist/colors";
import { createUUID } from "node-library/dist/helpers/request_helper";
import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendTempFilePasswordManagement,
} from "node-library/dist/portal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	GreenButton,
	OutlinedButton,
} from "../../../../common-components/button";
import { CustomTextInput } from "../../../../common-components/inputs";
import { ModalWithButtons } from "../../../../common-components/modals/modal";
import { generateStrongPassword } from "../../../../helpers/tempFilePasswordHelper";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	addOrEditFilePassword: (file: FrontendTempFilePasswordManagement) => void;

	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	filePassword?: FrontendTempFilePasswordManagement;
}

export default function AddOrEditFilePasswordModal(props: Props) {
	const { t: translation } = useTranslation();

	const { open, setOpen } = props;

	const [name, setName] = useState<string>("");

	const [password, setPassword] = useState<string>("");

	//validations
	const [userNameErrorMsg, setUserNameErrorMsg] = useState<string>("");

	const [passwrodErrorMsg, setPasswordErrorMsg] = useState<string>("");

	const [loading, setLoading] = useState<boolean>(false);

	const fieldsForRegistration: Array<any> = [
		{
			id: "user-username-input",
			label: `${translation("Name")}`,
			inputType: "text",
			value: name,
			setValue: setName,
			required: true,
			errorMsg: userNameErrorMsg,
			setErrorMsg: setUserNameErrorMsg,
		},
	];

	const passwordFields = [
		{
			id: "user-password-input",
			label: `${translation("Password")}`,
			inputType: "password",
			value: password,
			setValue: setPassword,
			required: true,
			errorMsg: passwrodErrorMsg,
			setErrorMsg: setPasswordErrorMsg,
		},
	];

	useEffect(() => {
		if (open) {
			for (const field of fieldsForRegistration) {
				field.setErrorMsg(translation(""));
			}

			for (const field of passwordFields) {
				field.setErrorMsg(translation(""));
			}

			setName(props.filePassword?.name || "");
			setPassword(props.filePassword?.password || "");
		}
	}, [open]);

	function handleSubmitInfo() {
		let hasError: boolean = false;
		for (const field of fieldsForRegistration) {
			if (
				field.required &&
				(!field.value || (field.value as string).trim().length == 0)
			) {
				field.setErrorMsg(translation("MissingInformation"));
				hasError = true;
			} else {
				field.setErrorMsg("");
			}
		}
		for (const field of passwordFields) {
			if (
				field.required &&
				(!field.value || (field.value as string).trim().length == 0)
			) {
				field.setErrorMsg(translation("MissingInformation"));
				hasError = true;
			} else {
				field.setErrorMsg("");
			}
		}

		if (hasError) {
			return;
		}
		handleSubmit();
	}

	function handleSubmit() {
		let newFile: FrontendTempFilePasswordManagement;
		if (props.filePassword) {
			newFile = {
				...props.filePassword,
				name,
				password,
			};
		} else {
			newFile = {
				id: createUUID(),
				name,
				password,
			};
		}
		props.addOrEditFilePassword(newFile);
		setOpen(false);
	}

	const fileInputs: Array<React.ReactNode> = fieldsForRegistration.map(
		(field, index) => {
			return (
				<CustomTextInput
					id={field.id}
					key={field.id}
					value={field.value}
					setValue={field.setValue}
					label={field.label}
					type={field.inputType}
					required={field.required}
					disabled={field.disabled}
					errorMsg={field.errorMsg}
					setErrorMsg={field.setErrorMsg}
				></CustomTextInput>
			);
		}
	);

	const passwordInputs: Array<React.ReactNode> = passwordFields.map(
		(field, index) => {
			return (
				<CustomTextInput
					id={field.id}
					key={field.id}
					value={field.value}
					setValue={field.setValue}
					label={field.label}
					type={field.inputType}
					required={field.required}
					errorMsg={field.errorMsg}
					setErrorMsg={field.setErrorMsg}
				></CustomTextInput>
			);
		}
	);

	const generatePasswordButton: React.ReactNode = (
		<OutlinedButton
			id="generate-password-button"
			size="small"
			children={translation("GeneratePassword")}
			onClick={() => {
				setPassword(generateStrongPassword());
			}}
			outlineColor={NeutralColor.NEUTRAL_GREY_950}
		></OutlinedButton>
	);

	const addEditUserModalContent: React.ReactNode = (
		<div className="registration-input-content">
			{fileInputs[0]}

			{passwordInputs[0]}
			{generatePasswordButton}
		</div>
	);

	const buttonText: string = props.filePassword
		? translation("Edit")
		: translation("Create");

	const addEditUserModal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={
				props.filePassword
					? translation("EditEntry")
					: translation("CreateEntry")
			}
			open={open}
			setOpen={setOpen}
			buttons={[
				<GreenButton
					key="submit-file-change-button"
					id="submit-file-change-button"
					children={buttonText}
					onClick={handleSubmitInfo}
				></GreenButton>,
			]}
		>
			{addEditUserModalContent}
		</ModalWithButtons>
	);
	return addEditUserModal;
}
